import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import TextField from "@material-ui/core/TextField";
import AddAlert from "@material-ui/icons/AddAlert";
import Snackbar from "../../components/Snackbar/Snackbar";
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import fetchAPI from "../../util/swt/fetchAPI";
import {METHOD} from "../../util/enum/method";
import {endpoints} from "../../util/swt/endpoints";
import {useHistory, useLocation} from "react-router-dom";

const useStyles = makeStyles(styles);

export default function ChangePasswordPage() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");

  const preEmail = (location && location.state && location.state.email) || '';

  const [email, setEmail] = React.useState(preEmail);
  const [oldPassword, setOldPassword] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [passwordRepeat, setPasswordRepeat] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [alertSuccess, setAlertSuccess] = React.useState(false);
  const [alertError, setAlertError] = React.useState(false);
  const [message, setMessage] = React.useState("");

  const handleSubmit = async (ev) => {
    ev && ev.preventDefault();
    try {
      if (!email || email.trim() === "") {
        setMessage('Email inválido');
        setAlertError(true);
        setTimeout(() => setAlertError(false), 4000);
        return;
      }
      if (oldPassword.trim() === '') {
        setMessage('Ingrese la clave anterior');
        setAlertError(true);
        setTimeout(() => setAlertError(false), 4000);
        return;
      }
      if (password === oldPassword) {
        setMessage('La clave nueva no puede ser igual a la anterior');
        setAlertError(true);
        setTimeout(() => setAlertError(false), 4000);
        return;
      }
      if (password !== passwordRepeat) {
        setMessage('Las claves no coinciden');
        setAlertError(true);
        setTimeout(() => setAlertError(false), 4000);
        return;
      }

      setLoading(true);
      const data = await fetchAPI(endpoints.temporalPassword, METHOD.POST, {
        oldPassword: oldPassword,
        password: password,
        confirmPassword: passwordRepeat,
        email: email
      });
      setLoading(false);
      if (data && data.status === -1) {
        setMessage(data.message || 'Error');
        setAlertError(true);
        setTimeout(() => setAlertError(false), 4000);
      } else {
        setMessage('Contraseña cambiada correctamente. Redirigiendo al login...');
        setAlertSuccess(true);
        setTimeout(() => {
          setAlertSuccess(false);
          history.push('/auth/login-page');
        }, 2500);
      }
    } catch (err) {
      setLoading(false);
      setMessage(err.message || 'Error al cambiar la contraseña');
      setAlertError(true);
      setTimeout(() => setAlertError(false), 4000);
    }
  };

  React.useEffect(() => {
    let id = setTimeout(function () {
      setCardAnimation("");
    }, 500);
    return function cleanup() {
      window.clearTimeout(id);
    };
  }, []);

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <Snackbar
          place="tr"
          color="success"
          icon={AddAlert}
          message={message}
          open={alertSuccess}
          closeNotification={() => setAlertSuccess(false)}
          close
        />
        <Snackbar
          place="tr"
          color="danger"
          icon={AddAlert}
          message={message}
          open={alertError}
          closeNotification={() => setAlertError(false)}
          close
        />

        <GridItem xs={12} sm={8} md={4}>
          <form onSubmit={handleSubmit}>
            <Card
              login
              className={`${classes.cardHidden} ${cardAnimaton}`}
              style={{
                borderRadius: "20px",
                boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                backdropFilter: "blur(12px)",
                overflow: "hidden",
              }}
            >
              <CardHeader
                className={`${classes.cardHeader} ${classes.textCenter}`}
                style={{
                  background: "linear-gradient(135deg, #0BA360 0%, #3FD1A7 100%)",
                  color: "#fff",
                  padding: "25px",
                }}
              >
                <h4 className={classes.cardTitle} style={{ fontWeight: "600" }}>
                  Cambiar Contraseña
                </h4>
              </CardHeader>

              <CardBody style={{ padding: "30px 25px" }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Correo Electrónico"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={classes.input}
                  style={{ marginBottom: 12 }}
                />

                <TextField
                  fullWidth
                  variant="outlined"
                  label="Clave Anterior"
                  type="password"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  className={classes.input}
                  style={{ marginBottom: 12 }}
                />

                <TextField
                  fullWidth
                  variant="outlined"
                  label="Nueva Clave"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={classes.input}
                  style={{ marginBottom: 12 }}
                />

                <TextField
                  fullWidth
                  variant="outlined"
                  label="Repetir Nueva Clave"
                  type="password"
                  value={passwordRepeat}
                  onChange={(e) => setPasswordRepeat(e.target.value)}
                  className={classes.input}
                />

              </CardBody>

              <CardFooter className={classes.justifyContentCenter} style={{ padding: "20px" }}>
                <Button
                  color="info"
                  size="lg"
                  block
                  type="submit"
                  disabled={loading}
                  style={{
                    background: "linear-gradient(90deg, #0BA360 0%, #3FD1A7 100%)",
                    borderRadius: "10px",
                    fontWeight: "bold",
                    padding: "12px",
                    color: "#fff",
                    fontSize: "16px",
                  }}
                >
                  {loading ? 'Procesando...' : 'Cambiar Contraseña'}
                </Button>
                <div style={{ marginTop: 12, textAlign: 'center' }}>
                  <Button
                    color="transparent"
                    size="sm"
                    onClick={() => history.push('/auth/login-page')}
                    style={{ textTransform: 'none', color: '#0BA360', fontWeight: 600 }}
                  >
                    Volver al Login
                  </Button>
                </div>
              </CardFooter>
            </Card>
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
}

